import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import SitesSearch from '../SitesSearch'
import Site from '../Site'
import { Match } from 'types'

interface SitesManagerProps {
  match: Match
}

const SitesManager: React.FC<SitesManagerProps> = ({ match }) => {
  return (
    <ErrorBoundary>
      <Switch>
        <Route component={Site} path={`${match.path}/:id`} />
        <Route component={SitesSearch} path={match.path} />
      </Switch>
    </ErrorBoundary>
  )
}

export default SitesManager
